import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

/**
 * @component QuestionWriting
 * @description
 * Componente que muestra un área de texto para que el usuario escriba su respuesta.
 * Incluye un contador de palabras dinámico. Es utilizado en la sección Writing del examen.
 *
 * @param {Object} props
 * @param {string} props.value - Texto actual ingresado por el usuario
 * @param {Function} props.onChange - Función que se ejecuta al cambiar el contenido del textarea. Retorna un objeto con `{ type: 'text', value }`
 *
 * @returns {JSX.Element}
 *
 * @example
 * <QuestionWriting
 *   value="This is my answer"
 *   onChange={(val) => console.log(val)}
 * />
 */
const QuestionWriting = ({ value, onChange }) => (
	<Row className="mt-3 justify-content-center">
		<Col xl={8}>
			<Form.Group controlId="writtenAnswer">
				<Form.Control
					as="textarea"
					rows={5}
					value={value || ''}
					onChange={(e) => onChange({ type: 'text', value: e.target.value })}
				/>
				<div className="text-end mt-1">
					<small>{value?.trim().split(/\s+/).filter(Boolean).length || 0} words</small>
				</div>
			</Form.Group>
		</Col>
	</Row>
);

export default QuestionWriting;